import { UseFormReturn } from 'react-hook-form';

import { CustomField, CustomFieldChoice, CustomFieldType } from '../../Shared/types';
import { Checkbox } from '../../Shared/UI/Checkbox';
import CheckboxLabel from '../../Shared/UI/CheckboxLabel';
import ErrorMessage from '../../Shared/UI/ErrorMessage';
import { Input } from '../../Shared/UI/Input';
import InputDescription from '../../Shared/UI/InputDescription';
import InputGroup from '../../Shared/UI/InputGroup';
import InputLabel from '../../Shared/UI/InputLabel';
import { Radio } from '../../Shared/UI/Radio';
import RadioLabel from '../../Shared/UI/RadioLabel';

export interface HasCustomFieldEntriesData {
  custom_field_entries: {
    field_id: string;
    value: string;
    choices: string[];
  }[];
}

export type CustomFieldInputFormApi = Pick<UseFormReturn<HasCustomFieldEntriesData>, 'register' | 'formState'>;

interface CustomFieldInputProps {
  form: CustomFieldInputFormApi;
  field: CustomField & { choices: CustomFieldChoice[]; };
  index: number;
}

export const CustomFieldInput = ({
  form, index, field,
}: CustomFieldInputProps) => {
  const { register, formState: { errors } } = form;

  const path = `custom_field_entries.${index}` as const;
  const id = `custom_field_entry_${field.id}`;

  return (
    <InputGroup>
      <InputLabel
        required={field.required}
        valid={!errors.custom_field_entries?.[index]}
        htmlFor={id}
      >
        {field.title}
      </InputLabel>

      {field.description && (
        <InputDescription className="whitespace-pre-line">
          {field.description}
        </InputDescription>
      )}

      {field.type == CustomFieldType.ShortText && (
        <Input
          {...register(`${path}.value`, { required: field.required })}
          id={id}
          aria-invalid={!!errors.custom_field_entries?.[index]}
        />
      )}

      {field.type == CustomFieldType.Option && field.choices.map((choice) => (
        <RadioLabel key={choice.id}>
          <Radio
            {...register(`${path}.choices.0`, { required: field.required })}
            value={choice.id}
            aria-invalid={!!errors.custom_field_entries?.[index]}
          />
          <span>
            {choice.value}
          </span>
        </RadioLabel>
      ))}

      {field.type == CustomFieldType.Selection && field.choices.map((choice) => (
        <CheckboxLabel key={choice.id}>
          <Checkbox
            {...register(`${path}.choices`, { required: field.required })}
            value={choice.id}
            aria-invalid={!!errors.custom_field_entries?.[index]}
          />
          <span>
            {choice.value}
          </span>
        </CheckboxLabel>
      ))}

      <ErrorMessage error={errors.custom_field_entries?.[index]?.value} attribute={field.title} />
      <ErrorMessage error={errors.custom_field_entries?.[index]?.choices?.[0]} attribute={field.title} />
    </InputGroup>
  );
};

